/** Matches CreateCustomerVitalsDto / UpdateCustomerVitalsDto + customerVitals schema */
const VITALS_NUMBER_FIELDS = [
  'totalBodyWater',
  'protein',
  'mineral',
  'bodyFatMass',
  'weight',
  'sMM',
  'bMI',
  'pBF',
  'waistHipRatio',
  'visceralFatLevel',
  'height',
] as const;

function appendNumericFields(
  source: Record<string, unknown>,
  target: Record<string, unknown>,
): void {
  for (const key of VITALS_NUMBER_FIELDS) {
    const value = source[key];
    if (value === undefined || value === null || value === '') {
      continue;
    }
    const numeric = Number(value);
    if (!Number.isNaN(numeric)) {
      target[key] = numeric;
    }
  }
}

/** POST /api/v1/branches/:branchId/customers/vitals — memberId + vitals metrics only */
export function buildCreateCustomerVitalsPayload(
  bodySpec: Record<string, unknown>,
  memberId: string,
): Record<string, unknown> {
  const payload: Record<string, unknown> = { memberId: String(memberId) };
  appendNumericFields(bodySpec, payload);
  return payload;
}

/** PUT /api/v1/branches/:branchId/customers/vitals — _id + memberId + vitals metrics only */
export function buildUpdateCustomerVitalsPayload(
  bodySpec: Record<string, unknown>,
  memberId: string,
): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    _id: bodySpec._id != null ? String(bodySpec._id) : bodySpec._id,
    memberId: String(memberId),
  };
  appendNumericFields(bodySpec, payload);
  return payload;
}
